import { Controller } from "@hotwired/stimulus"

// vaiAlPasso di components/verifica/StatoValidazione.js: porta in vista un passo della scheda, aperto (se è chiuso
// si preme il suo «Apri»). Sulla scheda: con ?passo=5 («Conferma i campi dei moduli» dalla barra di un progetto) il
// passo 5 scorre in vista dopo 300 ms, senza aprirlo, come l'effetto dell'originale.
//   <div data-controller="vai-al-passo"> … <button data-action="vai-al-passo#vai" data-vai-al-passo-passo-param="4">
const PASSO_TESTID = { 1: "passo-link", 2: "passo-import", 3: "passo-documenti", 4: "passo-dati", 5: "passo-moduli" }

export default class extends Controller {
  connect() {
    if (new URLSearchParams(window.location.search).get("passo") !== "5") return
    this.timer = setTimeout(() => this.passo(5)?.scrollIntoView?.({ behavior: "smooth", block: "start" }), 300)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  vai(event) {
    const n = event.params.passo
    const el = this.passo(n)
    if (!el) return
    if (el.getAttribute("data-aperto") === "no") el.querySelector(`[data-testid="${PASSO_TESTID[n]}-apri"]`)?.click()
    el.scrollIntoView?.({ behavior: "smooth", block: "start" })
  }

  passo(n) {
    return PASSO_TESTID[n] ? document.querySelector(`[data-testid="${PASSO_TESTID[n]}"]`) : null
  }
}
